<template>
  <main class="p-3" @click="showMenu = false">
    <!-- ## FILTERS ## -->
    <header class="header-container row align-center no-gutters mb-4">
      <!-- Type of Projects -->
      <div
        class="flex align-center col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-mobile-4"
      >
        <h1 class="forza-bold text-uppercase mr-3">
          Quote Request #{{ quote && quote.quote_id }}
        </h1>

        <!-- Menu -->
        <div id="menu">
          <img
            src="@/assets/icons/ui/ellipsis-vertical-circle-outline.svg"
            alt="menu icon"
            @click.stop="showMenu = !showMenu"
            :class="{ active: showMenu }"
          />
          <ul class="menu-actions-container" :class="{ active: showMenu }">
            <!-- <li>
              <CartSVG :fillColor="'#0751ed'" /><span
                >Add all to shopping cart</span
              >
            </li>
            <li>
              <BasketSVG :fillColor="'#0751ed'" /><span>Create OMG Store</span>
            </li> -->
            <li @click="showEmailModal = true">
              <EmailSVG :fillColor="'#0751ed'" /><span>Email this quote</span>
            </li>
            <li @click="downloadDecorationReport()">
              <PictureSVG :fillColor="'#0751ed'" />
              <span>Download decoration report</span>
            </li>
            <li>
              <TrashSVG :fillColor="'#0751ed'" /><span>Mark as complete</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- By Title -->
      <router-link to="/dashboard/quotes" class="btn"
        ><img src="@/assets/icons/ui/arrow-back-outline.svg" alt="back arrow" />
        Back to All Quote Requests</router-link
      >
    </header>

    <template v-if="!loading">
      <MyQuotesTable
        :quotes="[quote]"
        :showRepsFilter="false"
        :showLink="false"
      />

      <section id="customer-row">
        <article class="customer-info">
          <div class="customer-info-row">
            <img src="@/assets/icons/ui/call-outline.png" alt="phone icon" />
            <a
              :href="`tel:${quote.customer_data && quote.customer_data.phone}`"
              >{{ quote.customer_data && quote.customer_data.phone }}</a
            >
          </div>
          <div class="customer-info-row">
            <img src="@/assets/icons/ui/mail-outline.png" alt="email icon" />
            <a :href="`mailto:${quote.email}`">{{ quote.email }}</a>
          </div>
          <div class="customer-info-row">
            <img
              src="@/assets/icons/ui/location-outline.png"
              alt="location icon"
            />
            <p>{{ quoteAddress }}</p>
          </div>
        </article>
        <article class="customer-comments">
          <p class="title">Customer Comment</p>
          <p>
            {{ quote.customer_data && quote.customer_data.comment }}
          </p>
        </article>
        <article class="rep-notes"></article>
      </section>

      <section id="locker-products">
        <MyQuotesDetailsItem
          v-for="(product, i) in quoteProducts"
          :key="'product-' + i"
          :product="product"
          :showPrices="showPrices"
        />
        <!-- Footer -->
        <div class="locker-products-footer">
          <!-- Message -->
          <div class="message">
            <p class="title slate-bold">
              your Margin on this Quote Is ${{ finalMargin }}!
            </p>
            <p>
              Start by collecting payment from your customer. Once you are ready
              to order, take each item into the builder and Add to Cart. Founder
              Sport Group will take it from there 👍
            </p>
          </div>
          <!-- Total -->
          <div class="total">
            <div class="subtotal-row">
              <p>Total Quote Value</p>
              <span>{{
                showPrices ? `$${finalPrice}` : "No Pricing Shown"
              }}</span>
            </div>
            <div class="subtotal-row">
              <p>Your Total Cost</p>
              <span>${{ finalMSRP }}</span>
            </div>
          </div>
        </div>
      </section>
    </template>

    <Loader v-else />
    <!-- Send Email Modal -->
    <transition name="fade">
      <Modal
        v-if="showEmailModal"
        :hideButtonsContainer="true"
        :headerTitle="'Email a Copy of this Quote Request'"
        @closeModal="closeSendEmailModal()"
      >
        <template #content>
          <InputText
            :inputName="'email'"
            :inputLabel="'Send To'"
            :inputType="'email'"
            :labelWithDots="true"
            :focusOnMount="true"
            :errors="triedToSendEmail && !isEmailValid ? ['email'] : []"
            v-model="email"
          />
          <p class="text mb-2">
            We will forward a complete copy of this quote request to the email
            above.
          </p>
          <label id="include-price-info-label">
            <input
              type="checkbox"
              name="show-price-info"
              id="include-price-info"
              v-model="includePricingInformation"
              :checked="includePricingInformation"
            />
            <p class="text">Include Pricing information</p>
          </label>

          <button
            type="submit"
            class="btn btn-black slate-bold"
            id="send-quote-btn"
            :disabled="loadingSendEmail"
            @click="sendEmail()"
          >
            {{ loading ? "Loading..." : "Send Quote Summary" }}
          </button>
        </template>
      </Modal>
    </transition>
    <!-- Loader Modal -->
    <transition name="fade">
      <ModalLoader
        v-if="showLoaderModal"
        :withMessage="true"
        :message="loaderModalMessage"
      />
    </transition>

    <transition name="fade"
      ><ModalAlert
        v-if="showEmailSentModal"
        :isSuccess="true"
        :title="'Email Sent'"
        :text="`The email has been successfully sent to ${this.email}`"
        @closeModal="handleCloseAlertModal()"
      />
    </transition>
  </main>
</template>

<script>
import MyQuotesTable from "@/components/Dashboard/Messages/MyQuotesTable.vue";
import MyQuotesDetailsItem from "@/components/Dashboard/Messages/MyQuotesDetailsItem.vue";
import Loader from "@/components/Utils/Loader.vue";
import Modal from "@/components/Utils/Modal.vue";
import ModalAlert from "@/components/Utils/ModalAlert.vue";
import ModalLoader from "@/components/Utils/ModalLoader.vue";
import InputText from "@/components/Utils/InputText.vue";
// import BasketSVG from "@/components/Utils/Svgs/BasketSVG.vue";
// import CartSVG from "@/components/Utils/Svgs/CartSVG.vue";
import EmailSVG from "@/components/Utils/Svgs/EmailSVG.vue";
import PictureSVG from "@/components/Utils/Svgs/PictureSVG.vue";
import TrashSVG from "@/components/Utils/Svgs/TrashSVG.vue";
import axios from "axios";
import { mapActions, mapState } from "vuex";
export default {
  name: "MyQuoteDetails",

  data() {
    return {
      loading: false,
      quote: {},
      showMenu: false,

      // Send Email
      email: "",
      includePricingInformation: false,
      loadingSendEmail: false,
      showEmailModal: false,
      showEmailSentModal: false,
      triedToSendEmail: false,

      //Decoration Report
      loadingDownloadDecorationReport: false,
    };
  },

  components: {
    // BasketSVG,
    // CartSVG,
    EmailSVG,
    PictureSVG,
    TrashSVG,
    InputText,
    Loader,
    Modal,
    ModalAlert,
    ModalLoader,
    MyQuotesTable,
    MyQuotesDetailsItem,
  },

  computed: {
    ...mapState(["auth", "settings", "lockerModule"]),

    decorationReportLink() {
      return `${this.settings.endpoint}/download-decoration-report/${this.quote?.quote_id}`;
    },

    finalMargin() {
      return (this.finalPrice - this.finalMSRP).toFixed(2);
    },

    finalMSRP() {
      return Number(
        this.quoteProducts?.reduce(
          (acc, pr) =>
            acc +
            (Number(pr?.productMsrp) + Number(pr?.decorationsMsrp)) *
              pr?.quantity,
          0
        )
      )?.toFixed(2);
    },

    finalPrice() {
      return Number(
        this.quoteProducts?.reduce(
          (acc, pr) =>
            acc +
            (Number(pr?.productPrice) + Number(pr?.decorationsPrice)) *
              pr?.quantity,
          0
        )
      )?.toFixed(2);
    },

    quoteProducts() {
      return this.quote?.order_data?.map((quoteProductData) => {
        return quoteProductData?.uniform
          ? {
              ...quoteProductData?.uniform,
              ...quoteProductData?.uniform?.data,
            }
          : {};
      });
    },

    quoteAddress() {
      if (!this.quote.customer_data) return null;

      const { address, street, town, state } = this.quote.customer_data;

      return address
        ? address
        : street && town && state
        ? `${street}, ${town}, ${state}`
        : "N/A";
    },

    isEmailValid() {
      return String(this.email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },

    loaderModalMessage() {
      return this.loadingDownloadDecorationReport
        ? "Generating your decoration report..."
        : "Sending email...";
    },

    showLoaderModal() {
      return this.loadingDownloadDecorationReport || this.loadingSendEmail;
    },

    showPrices() {
      return !!this.quote?.project?.show_prices;
    },
  },

  methods: {
    ...mapActions("lockerModule", ["getLockerByCode"]),
    closeSendEmailModal() {
      // if (!this.loadingSendEmail) {
      //Todo: Uncomment when the functionallity is ready
      this.showEmailModal = false;
      this.triedToSendEmail = false;
      // }
    },

    async downloadDecorationReport() {
      try {
        this.loadingDownloadDecorationReport = true;

        const response = await axios({
          url: this.decorationReportLink,
          method: "GET",
          responseType: "blob", // important
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `[${this.quote.quote_id}]-FSG-Decoration-Report.zip`
        );
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingDownloadDecorationReport = false;
      }
    },

    async getQuote(reset) {
      if (reset) this.setPage(1);
      const quoteId = this.$route.params.id;
      await axios
        .get(this.settings.endpoint + "api/v2/lockers/quotes/" + quoteId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.auth.apiToken,
          },
        })
        .then((response) => {
          this.quote = response.data;
        })
        .catch((error) => {
          this.$store.dispatch("showToast", {
            txt: error,
            type: "error",
          });
        });
    },

    handleCloseAlertModal() {
      this.showEmailSentModal = false;
    },

    async sendEmail() {
      this.triedToSendEmail = true;
      if (this.isEmailValid) {
        try {
          this.loadingSendEmail = true;

          const url = `${this.settings.endpoint}api/v2/lockers/quotes/share/${this.quote.quote_id}`;
          const params = {
            email: this.email,
            show_prices: this.includePricingInformation,
          };
          const settings = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.auth.apiToken,
            },
          };

          await axios.post(url, params, settings);

          this.showEmailSentModal = true;
        } catch (error) {
          this.loadingSendEmail = false;
          console.log(error);
        } finally {
          this.loadingSendEmail = false;
          this.showEmailModal = false;
        }
      }
    },
  },

  async mounted() {
    this.loading = true;
    await this.getQuote();
    await this.getLockerByCode(this.quote.locker_code);
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
header {
  h1 {
    font-size: 1.75rem;
  }

  a.btn {
    background: none;
    border: 1px solid $grey-dark !important;
    border-radius: 6px;
    color: $grey-dark;
    width: fit-content !important;
    margin-left: auto;
    transition: all 0.2s;
    &:hover {
      transform: scale(1.05);
    }
  }

  #menu {
    position: relative;
    img {
      background: #eceded;
      border-radius: 50%;
      padding: 0.2em;
      cursor: pointer;
      transition: 0.2s;
      &:hover,
      &.active {
        filter: invert(1);
      }
    }
    ul.menu-actions-container {
      position: absolute;
      top: 50%;
      left: 50%;
      background: white;
      border-radius: 8px;
      box-shadow: 0px -1.87px 18.2546px rgba(40, 42, 48, 0.16);
      padding: 0.5em;
      display: none;
      transition: 0.2s;
      width: 220px;
      z-index: 10;

      &.active {
        display: flex;
        flex-direction: column;
      }

      li {
        display: flex;
        align-items: center;
        height: 2em;
        padding: 1em 0.5em;
        margin-bottom: 1em;
        cursor: pointer;
        transition: 0.2s;
        &:hover {
          span {
            text-decoration: underline;
          }
        }
        svg {
          margin-right: 0.5em;
          width: 1.2em;
        }
        span {
          color: #0751ed;
          text-transform: capitalize;
        }
      }
    }
  }
}

#customer-row {
  background: white;
  border-bottom: 1px solid black;
  display: flex;
  margin-bottom: 1rem;
  padding: 1.25rem;
  .customer-info {
    width: 25%;
    .customer-info-row {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      p,
      a {
        color: black;
      }
      img {
        width: 1rem;
        margin-right: 0.9rem;
      }
    }
  }

  .customer-comments {
    width: 25%;
    .title {
      color: $grey-dark;
      margin-bottom: 0.8rem;
    }
  }
}

#locker-products {
  .locker-products-footer {
    display: flex;
    justify-content: space-between;
    .message {
      background: $blueBackground;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      padding: 1rem 1rem 0.75rem 1.5rem;
      width: 65%;
      p {
        color: $blue;
      }
      .title {
        text-transform: capitalize;
        margin-bottom: 0.75rem;
      }
    }

    .total {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      width: 30%;
      margin-right: 2%;
      .subtotal-row {
        display: flex;
        align-items: center;
        justify-content: space-between;

        p,
        span {
          color: $dark;
        }

        span {
          font-size: 1.75rem;
        }
      }
    }
  }
}

::v-deep .modal {
  position: fixed !important;

  .btn {
    max-width: 200px;
    margin-left: auto;
    margin-right: auto;

    &:focus {
      outline: 1px solid black !important;
      border: 2px solid white !important;
    }
  }

  #include-price-info-label {
    display: flex;
    flex-direction: row;
    align-items: center;
    input {
      margin-right: 0.5rem;
    }
  }
}
</style>
